var supermodels = require('supermodels.js')
var File = require('./file')

var Files = supermodels([File])

module.exports = Files
